import { jsx as o, jsxs as r } from "react/jsx-runtime";
import { useRef as T } from "react";
import { useTranslation as I, Trans as A } from "react-i18next";
import b from "reactjs-popup";
import l from "classnames";
import { EditorMenu as E, Checkmark as c, ArrowRightBold as h } from "@forma/forma-ui-kit";
import k from "../../../data/mock.js";
const R = "forma-filling__editor-options-menu__button", S = "forma-filling__editor-options-menu__active", j = "forma-filling__editor-options-menu__list", B = "forma-filling__editor-options-menu__sublist", D = "forma-filling__editor-options-menu__item", M = "forma-filling__editor-options-menu__disabled", O = "forma-filling__editor-options-menu__itemName", X = "forma-filling__editor-options-menu__arrow", $ = "forma-filling__editor-options-menu__checkmarkCircle", i = {
  button: R,
  active: S,
  list: j,
  sublist: B,
  item: D,
  disabled: M,
  itemName: O,
  arrow: X,
  checkmarkCircle: $
}, N = ({ items: p = [], selected: t, onClick: f, control: u, langPrefix: _ }) => p.length ? /* @__PURE__ */ o(
  b,
  {
    trigger: u,
    className: "options",
    position: ["right bottom", "right top", "right center", "left bottom", "left top", "left center"],
    arrow: !1,
    offsetX: 12,
    mouseLeaveDelay: 200,
    on: ["hover", "focus"],
    keepTooltipInside: !1,
    nested: !0,
    children: /* @__PURE__ */ o("div", { className: l(i.list, i.sublist), children: p.map((s) => /* @__PURE__ */ r(
      "button",
      {
        className: i.item,
        onClick: () => f(s),
        children: [
          t && t === s && /* @__PURE__ */ o(c, { className: i.checkmarkCircle }),
          /* @__PURE__ */ o("span", { className: i.itemName, children: /* @__PURE__ */ o(A, { i18nKey: `${_}.${s}`, components: { span: /* @__PURE__ */ o("span", {}) } }) })
        ]
      },
      s
    )) })
  }
) : null, H = ({
  id: p = "",
  selected: t = {},
  onClickRemove: f,
  onClickTextType: u,
  onClickTextCase: _,
  onClickAbbreviation: s
}) => {
  const m = T(null), { t: a } = I(), g = () => {
    var e;
    (e = m.current) == null || e.close(), f(p);
  }, d = (e) => {
    var n;
    (n = m.current) == null || n.close(), u(e);
  }, C = (e) => {
    var n;
    (n = m.current) == null || n.close(), _(e);
  }, y = (e) => {
    var n;
    (n = m.current) == null || n.close(), s(e);
  }, v = !t.type || t.type === "date", w = !t.type || t.type === "decimal" || t.type === "integer", P = !t.type || t.type === "money", W = !t.type || t.type === "firstname" || t.type === "familyname" || t.type === "middlename", x = t.type === "firstname" || t.type === "middlename";
  return /* @__PURE__ */ o(
    b,
    {
      trigger: (e) => /* @__PURE__ */ o("button", { className: l(i.button, e && i.active), children: /* @__PURE__ */ o(E, {}) }),
      className: "options",
      position: ["right top", "right bottom", "right center", "left top", "left bottom", "left center"],
      arrow: !1,
      offsetY: -2,
      offsetX: 6,
      keepTooltipInside: !1,
      ref: m,
      nested: !0,
      children: /* @__PURE__ */ r("div", { className: i.list, children: [
        /* @__PURE__ */ o("button", { className: i.item, onClick: g, children: a("delete") }),
        v && /* @__PURE__ */ o(
          N,
          {
            control: (e) => /* @__PURE__ */ r("button", { className: l(i.item, e && i.active), children: [
              t.inWords && !["P", "N"].includes(t.inWords) && /* @__PURE__ */ o(c, { className: i.checkmarkCircle }),
              a("date_in_words"),
              " ",
              /* @__PURE__ */ o(h, { className: i.arrow })
            ] }),
            items: k.dateItems,
            selected: t.inWords,
            onClick: d,
            langPrefix: "in_words"
          }
        ),
        P && /* @__PURE__ */ o(
          N,
          {
            control: (e) => /* @__PURE__ */ r("button", { className: l(i.item, e && i.active), children: [
              t.inWords && ["P", "A", "B"].includes(t.inWords) && /* @__PURE__ */ o(c, { className: i.checkmarkCircle }),
              a("price_in_words"),
              " ",
              /* @__PURE__ */ o(h, { className: i.arrow })
            ] }),
            items: k.priceItems,
            selected: t.inWords,
            onClick: d,
            langPrefix: "in_words_price"
          }
        ),
        w && /* @__PURE__ */ r("button", { className: i.item, onClick: () => d("N"), children: [
          t.inWords === "N" && /* @__PURE__ */ o(c, { className: i.checkmarkCircle }),
          a("numbers_in_words")
        ] }),
        W && /* @__PURE__ */ o(
          N,
          {
            control: (e) => /* @__PURE__ */ r("button", { className: l(i.item, e && i.active), children: [
              t.case && /* @__PURE__ */ o(c, { className: i.checkmarkCircle }),
              a("change_case"),
              " ",
              /* @__PURE__ */ o(h, { className: i.arrow })
            ] }),
            items: k.caseItems,
            selected: t.case,
            onClick: C,
            langPrefix: "in_case"
          }
        ),
        x && /* @__PURE__ */ r("button", { className: i.item, onClick: () => y(!t.short), children: [
          t.short && /* @__PURE__ */ o(c, { className: i.checkmarkCircle }),
          a("abbreviation")
        ] })
      ] })
    }
  );
};
export {
  H as EditorOptionsMenu,
  H as default
};
